"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendedLength = exports.TokenType = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var TokenType;
exports.TokenType = TokenType;

(function (TokenType) {
  TokenType["Words"] = "words";
  TokenType["Characters"] = "characters";
})(TokenType || (exports.TokenType = TokenType = {}));

var getWordsCount = function getWordsCount(text) {
  return text.split(/\s+/).filter(function (x) {
    return x.trim().length;
  }).length;
};

var getCharactersCount = function getCharactersCount(text) {
  return text.length;
};

var defaultGetRecommendedText = function defaultGetRecommendedText(tokenType) {
  return function (_ref) {
    var tokenCount = _ref.tokenCount,
        recommendedLength = _ref.recommendedLength;
    return "".concat(tokenCount, " ").concat(tokenType, " entered. ").concat(recommendedLength, " or fewer are recommended");
  };
};

var useRecommendedLength = function useRecommendedLength(_ref2) {
  var value = _ref2.value,
      tokenType = _ref2.tokenType,
      recommendedLength = _ref2.recommendedLength,
      getExceededText = _ref2.getExceededText,
      _ref2$getRecommendedT = _ref2.getRecommendedText,
      getRecommendedText = _ref2$getRecommendedT === void 0 ? defaultGetRecommendedText(tokenType) : _ref2$getRecommendedT,
      getErrorText = _ref2.getErrorText;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      footerText = _useState4[0],
      setFooterText = _useState4[1];

  var getFooterText = (0, _react.useCallback)(function (tokenCount) {
    var isError = !!getErrorText;
    var isWarning = !!getExceededText && tokenCount > recommendedLength;

    if (isError) {
      return !!getErrorText ? getErrorText() : '';
    }

    if (isWarning) {
      return !!getExceededText ? getExceededText({
        tokenCount: tokenCount,
        recommendedLength: recommendedLength
      }) : '';
    }

    return getRecommendedText({
      tokenCount: tokenCount,
      recommendedLength: recommendedLength
    });
  }, [recommendedLength, getExceededText, getRecommendedText, getErrorText]);
  var getTokenCount = (0, _react.useCallback)(function (enteredText) {
    switch (tokenType) {
      case TokenType.Words:
        return getWordsCount(enteredText);

      case TokenType.Characters:
        return getCharactersCount(enteredText);

      default:
        return 0;
    }
  }, [tokenType]);
  (0, _react.useEffect)(function () {
    var tokenCount = getTokenCount(value);
    setCount(tokenCount);
    setFooterText(getFooterText(tokenCount));
  }, [value, recommendedLength, getFooterText, getTokenCount]);
  var progress = count / recommendedLength;
  return {
    footerText: footerText,
    warning: count > recommendedLength,
    error: !!getErrorText,
    progress: Number.isNaN(progress) ? 0 : progress,
    count: count
  };
};

exports.useRecommendedLength = useRecommendedLength;